import Button from './ui/Button';
import Popup from './ui/Popup';
import locales from '../locales.json';

const { EXPIRED_TEXTS } = locales;

const LinkExpired = ({ onRegister }) => (
  <Popup titleId="expired-title" icon="!" tone="warn">
    <h1 className="sheet__title" id="expired-title">
      {EXPIRED_TEXTS.title}
    </h1>
    <p className="sheet__body">{EXPIRED_TEXTS.body}</p>

    <div className="pop__actions">
      <Button variant="primary" block autoFocus onClick={onRegister}>
        {EXPIRED_TEXTS.registerAgain}
      </Button>
    </div>
  </Popup>
);

export default LinkExpired;
